import { CommonModule } from '@angular/common'
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core'
import { RouterModule } from '@angular/router'
import { Media } from '../../enums/enums'

@Component({
  selector: 'ddc-profile-pic-only',
  templateUrl: './ddc-profile-pic-only.component.html',
  styleUrl: './ddc-profile-pic-only.component.scss',
  encapsulation: ViewEncapsulation.Emulated,
  standalone: true,
  imports: [CommonModule, RouterModule],
})
export class DdcProfilePicOnlyComponent implements OnInit {
  @Input('isProfilePicLoading') _isProfilePicLoading: boolean
  @Input('userProfilePic') _userProfilePic: string
  @Input('dynamicRoute') _dynamicRoute: string

  _assets = Media.ASSETS

  _DefaultProfilePic: string =
    'https://st3.depositphotos.com/6672868/13701/v/600/depositphotos_137014128-stock-illustration-user-profile-icon.jpg'

  constructor() {}

  ngOnInit(): void {
    if (
      this._userProfilePic === null ||
      this._userProfilePic === undefined ||
      this._userProfilePic === 'null'
    ) {
      this._assets = Media.EMPTY
      this._userProfilePic = this._DefaultProfilePic
    }
  }

  handleImageError(event: Event): void {
    const imgElement = event.target as HTMLImageElement
    imgElement.src = this._DefaultProfilePic
  }
}
